import Vue from 'vue/dist/vue.esm.js';

Vue.component('main-menu', {
  data() {
    return {
      mobileMenuOpen: false,
      activeSubmenu: '',
      tempData: [],
    }
  },
  props: [
    'menudata'
  ],
  computed: {
    filteredMenuData(){
      let newArray = []
      // menu_item_parent = parent element ID
      // Loop over each index, check if it has a parent
      // if menu_item_parent == 0, this is a root element
      // If it has a parent, remove the element, and add it to 'children' of the parent node
      for(let i = 0; i < this.menudata.length; i++){
        // If parent element, push to array
        if(this.menudata[i].menu_item_parent == 0){
          this.menudata[i].children = [];
          newArray.push(this.menudata[i])
        }else{
          // Otherwise, compare the menu_item_parent with ID
          // If it's a match, push it to 'children'
          for(let j = 0; j < newArray.length; j++){

            if(this.menudata[i].menu_item_parent == newArray[j].ID){
              newArray[j].children.push(this.menudata[i])
            }
          }
        }
      }
      return newArray;
    }
  },
  methods: {
    toggleMobileMenu: function(){
      this.mobileMenuOpen = !this.mobileMenuOpen
      document.body.classList.toggle('overflow-hidden');
      this.activeSubmenu = '';
    },
    setMobileSubmenu: function(el){
      this.activeSubmenu = el;
    },
    clearMobileSubmenu: function(){
      this.activeSubmenu = '';
    }
  }
});


new Vue({}).$mount('#menuWrapper');
